angular.module( 'acme.view.application.donations.config.list', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.donations.config.list.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var donationsConfigList = {
        name: 'application.donations.config.list',
        url: '/list/:type',
        params: {
          type: null,
        },
        views: {
          "subview-main": {
            controller: 'DonationsConfigListController',
            templateUrl: 'views/application/views/donations/config/list/list.tpl.html'
          }
        },
        data: {
          pageTitle: 'Config',
          enablePreferences: true
        }
      };

    $stateProvider
      .state(donationsConfigList);
});
